import { Typography } from "@mui/material";
import { DialogModal } from "components/modals/DialogModal";
import { textAuth } from "config/configMessages";
import { useValidateSessionQuery } from "features/security/auth";
import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getPrivileges } from "utils/generalUtils";
import { decryptStorage } from "utils/utils";
import { reset } from "features/dashboardMySelf/filterSlice";
import { useDispatch } from "react-redux";
export const ProtectedRoute = ({
  permisionConsult,
  redirectPath = "/logout",
  redirectDashboard = "/dashboard",
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation()
  const token = decryptStorage(localStorage.getItem("token"));
  const permisions = JSON.parse(
    decryptStorage(localStorage.getItem("dataUser"))
  );
  const dispatch = useDispatch();
  const { data, isError,refetch } = useValidateSessionQuery();
  useEffect(() => {
    dispatch(reset())
    refetch()
}, [location])

  useEffect(() => {
    if(isError){
        setShowModal(true)
    }
  }, [data,isError]);

  const closeModal = () => {
    setShowModal(false);
  };

  if (!token) {
    return <Navigate to={redirectPath} replace />;
  }
  // La función getPrivileges ahora maneja tanto arrays como strings
  if (permisions && !getPrivileges(permisions.role, permisionConsult)) {
    return <Navigate to={redirectDashboard} replace />;
  }

  return (
    <>
      <DialogModal
        open={showModal}
        onClose={closeModal}
        title="Expiración de sesión"
        textInfo={
          <Typography component="span" variant="body1">
            {textAuth.concurrentSession}
            <br />
          </Typography>
        }
        onClickHandler={() => {
          closeModal();
          navigate("/logout");
        }}
        buttonName="Aceptar"
      />
      {children}
    </>
  );
};
